import React, { useEffect, useState } from 'react';
import { TextButton } from '@Shared.Angular/flowingly.components/buttons/TextButton';
import { getService } from '@Client/runner.hooks/useService';
import {
  RecordingPhase,
  VIDEO_RECORDING_PHASE_CHANGED
} from '@Client/runner.services/video.recording.service';

export const StartRecordingButton = () => {
  const videoRecordingService = getService('videoRecordingService');
  const pubsubService = getService('pubsubService');

  const [phase, setPhase] = useState<RecordingPhase>(
    videoRecordingService.getRecordingPhase()
  );

  useEffect(() => {
    const subscriberId = 'flowingly.runner.start-recording-button';
    pubsubService.subscribe<RecordingPhase>(
      VIDEO_RECORDING_PHASE_CHANGED,
      (_event, newPhase) => setPhase(newPhase),
      subscriberId
    );
    return () => {
      pubsubService.unsubscribeAll(subscriberId);
    };
  }, []);

  return (
    <TextButton
      type="primary"
      text="Start Video Recorder"
      onClick={() => videoRecordingService.acquireMedia()}
      disabled={phase !== RecordingPhase.Inactive}
      testId="start-recording-button"
    />
  );
};
